import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            observables: {
                registerObservableNotifier: publicMethodUtils.extensionPublicAPI.immediate(
                    'observables.registerObservableNotifier'
                )
            }
        }
    }
}
